// Translation Department — API client
// Thin wrappers over /api/departments/{id}/glossary endpoints.

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

function _authHeader() {
  const t = localStorage.getItem("kc_token") || localStorage.getItem("token");
  return t ? { Authorization: `Bearer ${t}` } : {};
}

async function _send(method, path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ..._authHeader(),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let msg = `${method} ${path} failed (${res.status})`;
    try { const j = await res.json(); if (j?.detail) msg = typeof j.detail === "string" ? j.detail : JSON.stringify(j.detail); } catch (_) {}
    throw new Error(msg);
  }
  if (res.status === 204) return null;
  return res.json();
}

export const apiGetGlossary       = (deptId)                  => _send("GET",    `/departments/${deptId}/glossary`);
export const apiAddGlossaryEntry  = (deptId, entry)           => _send("POST",   `/departments/${deptId}/glossary/entries`, entry);
export const apiUpdateGlossaryEntry = (deptId, entryId, body) => _send("PUT",    `/departments/${deptId}/glossary/entries/${entryId}`, body);
export const apiDeleteGlossaryEntry = (deptId, entryId)       => _send("DELETE", `/departments/${deptId}/glossary/entries/${entryId}`);

export const GLOSSARY_CATEGORIES = [
  "Theology", "Worship", "Prayer", "Scripture",
  "Church Life", "Names and Titles", "Other",
];

// Resolve the WebSocket base URL from the HTTPS backend URL.
export function wsBaseUrl() {
  const base = process.env.REACT_APP_BACKEND_URL || "";
  return base.replace(/^http/, "ws");
}
